module.exports = __webpack_public_path__ + "img/112.d4bc63ac.png";